import { Tooltip } from 'antd';
import React from 'react';
import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const ExcelExport = (props) => {


    return <ExcelFile element={<Tooltip title="Excele Aktar">{props.downloadButton}</Tooltip>} filename={props.fileName}>
            {
                props.sheets.map(sheet => <ExcelSheet key={sheet.title} data={sheet.data} name={sheet.name}>
                    {sheet.keyTitles.map(kt => <ExcelColumn key={kt.key} label={kt.title} value={kt.key} />)}
                </ExcelSheet>)
            }
        </ExcelFile>
}

export default ExcelExport;
